import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row align-items-center" }
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = {
  key: 0,
  class: "input-group mb-3"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = {
  key: 1,
  class: "input-group mb-3"
}
const _hoisted_13 = {
  key: 2,
  class: "input-group mb-3"
}
const _hoisted_14 = {
  key: 3,
  class: "input-group mb-3"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "input-group mb-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "input-group mb-3" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = {
  key: 0,
  class: "text-center"
}
const _hoisted_22 = {
  key: 1,
  class: "text-center"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_class_image_modal = _resolveComponent("class-image-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "button", { onClick: _ctx.openModal }),
    _createElementVNode("div", {
      class: "modal",
      tabindex: "-1",
      id: `#modal-${_ctx.classId}`,
      ref: "modal"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "modal-title" }, "Nueva Clase", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "hidden",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schedule) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.schedule]
                ]),
                (_ctx.scheduleType != 'mmiColombia')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "input-group-text" }, "Tipo de clase", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "Default select example",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.type) = $event)),
                        disabled: _ctx.edit
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("option", { disabled: "" }, "Selecciona el tipo de clase", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("option", {
                          selected: "",
                          value: "blank"
                        }, "Clase en blanco", -1)),
                        (
                      _ctx.scheduleType == 'gtrSystem' || _ctx.scheduleType == 'academy'
                    )
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Object.entries(
                        _ctx.classList[_ctx.scheduleType]
                      ), ([key, val], ind) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: ind }, [
                                (key != 'blank')
                                  ? (_openBlock(), _createElementBlock("option", {
                                      key: 0,
                                      value: key
                                    }, _toDisplayString(val?.title), 9, _hoisted_10))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_9), [
                        [_vModelSelect, _ctx.type]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-text" }, "Título", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.title) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.title]
                  ])
                ]),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text" }, "Instructor", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        "aria-label": "Default select example",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.professor) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.professor]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.scheduleType == 'mmiColombia')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "input-group-text" }, "Fecha", -1)),
                      _createVNode(_component_VueDatePicker, {
                        modelValue: _ctx.date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.date) = $event)),
                        vertical: "",
                        "enable-time-picker": false,
                        "auto-apply": "",
                        class: "form-control p-0",
                        "min-date": new Date(),
                        format: _ctx.dateFormatting
                      }, null, 8, ["modelValue", "min-date", "format"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.scheduleType != 'mmiColombia')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "input-group-text" }, "Día", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "aria-label": "Default select example",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.day) = $event)),
                        disabled: _ctx.edit
                      }, [...(_cache[19] || (_cache[19] = [
                        _createStaticVNode("<option selected disabled> Selecciona el día de la semana </option><option value=\"monday\">Lunes</option><option value=\"tuesday\">Martes</option><option value=\"wednesday\">Miércoles</option><option value=\"thursday\">Jueves</option><option value=\"friday\">Viernes</option><option value=\"saturday\">Sábado</option><option value=\"sunday\">Domingo</option>", 8)
                      ]))], 8, _hoisted_15), [
                        [_vModelSelect, _ctx.day]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "input-group-text" }, "Hora", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.hour) = $event)),
                    disabled: _ctx.edit
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("option", {
                      selected: "",
                      disabled: ""
                    }, " Selecciona el día de la semana ", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour, ind) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: ind,
                        value: hour
                      }, _toDisplayString(hour), 9, _hoisted_18))
                    }), 128))
                  ], 8, _hoisted_17), [
                    [_vModelSelect, _ctx.hour]
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "input-group-text" }, "Activo", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.active) = $event))
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("option", {
                      selected: "",
                      disabled: ""
                    }, "Selecciona una opción", -1),
                    _createElementVNode("option", { value: "true" }, "Sí", -1),
                    _createElementVNode("option", { value: "false" }, "No", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.active]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "input-group-text" }, "Link", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.link) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.link]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.scheduleType != 'mmiColombia')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Dimensiones: 1024 x 484 px "))
                  : _createCommentVNode("", true),
                (_ctx.scheduleType == 'mmiColombia')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Dimensiones: 1024 x 576 px "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  style: _normalizeStyle([{"width":"90%","background-color":"rgba(0, 0, 0, 0.2)","margin":"0px auto"}, 
                  _ctx.scheduleType == 'mmiColombia'
                    ? 'aspect-ratio: 16/9;'
                    : 'aspect-ratio: 256/121;'
                ])
                }, [
                  _createElementVNode("img", {
                    src: _ctx.image,
                    style: {"width":"100%"}
                  }, null, 8, _hoisted_23)
                ], 4),
                _createVNode(_component_class_image_modal, {
                  "class-id": "classId",
                  onUpdateImage: _ctx.updateImage,
                  "image-width": "1024",
                  "image-height": _ctx.scheduleType != 'mmiColombia' ? '484' : '576',
                  "aspect-ratio": 
                  _ctx.scheduleType == 'mmiColombia' ? 16 / 9 : 256 / 121
                
                }, {
                  button: _withCtx(({ onClick }) => [
                    _createElementVNode("button", {
                      class: "btn btn-secondary mt-2",
                      onClick: onClick
                    }, " Cambiar imagen ", 8, _hoisted_24)
                  ]),
                  _: 1
                }, 8, ["onUpdateImage", "image-height", "aspect-ratio"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Cerrar "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveClass && _ctx.saveClass(...args)))
            }, " Guardar Cambios ")
          ])
        ])
      ])
    ], 8, _hoisted_1)
  ], 64))
}